var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headerTop"},[_c('a',{attrs:{"href":"http://www.chinaacc.com","target":"_blank"}},[_vm._v("正保会计网校")]),_c('div',{staticClass:"right"},[_vm._t("right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }